import {
    TActionType,
    TransactionType,
} from '../../../Utility/Tracking/DataSet/Transaction';
import { track, TrackMethod } from '../../../Utility/Tracking/Track';
import { trackTransaction } from '../../../Utility/Tracking/TrackingHelpers/Transaction';
import { IGameState } from '../../Game/IGameState';
import CardStateHelper from '../CardStateHelper';
import BaseBoosterBehavior from './BaseBoosterBehavior';

export default class HelperFriendPlusThreeBehavior extends BaseBoosterBehavior {
    public play(state: IGameState): IGameState {
        const targets: string[] = [];

        state = CardStateHelper.addNewCards(state, 3, targets);

        track('mFriendHelped', true);
        track('tLevelExtraCardsReceived', 3, TrackMethod.ADD);
        track('tHelperCards', 3, TrackMethod.ADD);
        trackTransaction(state, TransactionType.REWARD, TActionType.SOCIAL);

        return state;
    }
}
